import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Customer} from '../../model/Entities/Customer';
import {CustomerContactPerson} from '../../model/Entities/CustomerContactPerson';
import {FormControl, Validators} from '@angular/forms';
import {User} from '../../model/Entities/User';
import {ProductFileService} from '../../services/product-file.service';
import {ProductFile} from '../../model/Entities/ProductFile';

@Component({
    selector: 'product-file-add-dialog',
    templateUrl: './product-file-add.dialog.component.html',
    styleUrls: ['./product-file-add.dialog.component.scss']
})
export class ProductFileAddDialogComponent implements OnInit {

    private productId: number;
    private file: ProductFile = new ProductFile();
    private fileData: string;

    fileLoaded = false;

    private fileInput: ElementRef;

    @ViewChild('fileInput') set fileInputElement(fileInputElement: ElementRef) {
        this.fileInput = fileInputElement;

        if (!this.fileInput) {
            return;
        }

        this.openFileDialog();
    }

    private imagePreview: ElementRef;

    @ViewChild('imagePreview') set imagePreviewElement(imagePreviewElement: ElementRef) {
        this.imagePreview = imagePreviewElement;

        if (!this.imagePreview) {
            return;
        }

        this.imagePreview.nativeElement.src = this.fileData;
    }

    constructor(public dialog: MatDialogRef<ProductFileAddDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                protected productFileService: ProductFileService) {

        this.productId = data.productId;
    }

    ngOnInit(): void {
    }

    save(): void {
        this.productFileService.save(this.file).subscribe(() => {
            this.dialog.close(true);
        });
    }

    private openFileDialog(): void {
        this.fileLoaded = false;
        if (this.fileInput) {
            this.fileInput.nativeElement.click();
        }
    }

    private fileInputChanged(event: any): void {
        this.readFileFromInput(event.target);
    }

    private readFileFromInput(inputValue: any): void {
        const file: File = inputValue.files[0];
        const fileReader: FileReader = new FileReader();

        fileReader.onloadend = (e) => {
            this.fileLoaded = true;
            this.fileData = fileReader.result;

            this.file.productId = this.productId;
            this.file.setFileContent(fileReader.result, file.name);
        };
        fileReader.readAsDataURL(file);
    }
}



// WEBPACK FOOTER //
// /app/src/ProductsModule/ProductFileAddDialogComponent/product-file-add.dialog.component.ts